import { Directive, ElementRef, HostListener, Input, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { FlightUtil } from '../util/FlightUtil.model';
import { StringUtil } from '../util/StringUtil.model';

@Directive({
  selector: '[appAppFlightNumber]'
})
export class AppFlightNumberDirective {

  @Input() isList ? = 'false';
  @Input() isRange ? = 'false';
  regExp = (/[a-zA-Z0-9]/);
  regExpList = (/[a-zA-Z0-9,]/);
  regExpRange = (/[a-zA-Z0-9-]/);
  constructor(@Self() private ngControl: NgControl, private element: ElementRef) { }

  @HostListener('change') onChange(): void {
    const value: string = this.element.nativeElement.value;
    if (value !== '') {
      if (this.isList === 'true') {
        const valueList = value.split(',');
        let resultNumber = '';
        for (const valueAux of valueList) {
          if (valueAux) {
            if (!FlightUtil.isCorrectFormat(valueAux)) {
              const rectificateNumberAux: string = FlightUtil.flightNumberRectificate(valueAux);
              resultNumber = resultNumber ? (resultNumber + ',' + rectificateNumberAux) : rectificateNumberAux;
            } else {
              resultNumber = resultNumber ? (resultNumber + ',' + valueAux) : valueAux;
            }
          }
        }
        if (resultNumber) {
          this.ngControl.control.setValue(resultNumber.toUpperCase());
        }
      } else if (this.isRange === 'true') {
        const flightNumbers = StringUtil.getSeparateArrayOfRangeString(value);
        if (flightNumbers.length === 2) {
          let flightNumbersRangeRectificate = '';
          flightNumbers.forEach(flNumAux =>{
            if (!Number.isNaN(+flNumAux)) {
              if (!FlightUtil.isCorrectFormat(flNumAux)) {
                const rectificateNumber: string = FlightUtil.flightNumberRectificate(flNumAux);
                flightNumbersRangeRectificate += rectificateNumber;
                if (flightNumbersRangeRectificate.indexOf('-') === -1) {
                  flightNumbersRangeRectificate += '-';
                }
              }
            }
          });
          const arrayFligthNumberRectificate = StringUtil.getSeparateArrayOfRangeString(flightNumbersRangeRectificate);
          if (arrayFligthNumberRectificate.length === 2) {
            if (arrayFligthNumberRectificate[0] && arrayFligthNumberRectificate[1]) {
              this.ngControl.control.setValue(flightNumbersRangeRectificate.toUpperCase());
            }
          }
        }
      } else {
        if (!FlightUtil.isCorrectFormat(value)) {
          const rectificateNumber: string = FlightUtil.flightNumberRectificate(value);
          this.ngControl.control.setValue(rectificateNumber.toUpperCase());
        }
      }
    }
  }

  @HostListener('keypress', ['$event']) onKeyPress(evento: KeyboardEvent): boolean {
    const tecla = evento.key;
    const valor: string = this.element.nativeElement.value;
    if (this.isList === 'true') {
      if (!this.regExpList.test(tecla)) {
        this.ngControl.control.setValue(valor);
        return false;
      }
    } else if (this.isRange === 'true') {
      if (!this.regExpRange.test(tecla)) {
        this.ngControl.control.setValue(valor);
        return false;
      }
    } else {
      if (!this.regExp.test(tecla)) {
        this.ngControl.control.setValue(valor);
        return false;
      }
    }
  }
}
